import { X } from 'lucide-react';
import LeadForm from './LeadForm';

export const LeadFormModal = ({ isOpen, onClose, selectedProduct = null }) => {
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      data-testid="lead-form-modal"
    >
      {/* Overlay */}
      <div 
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative bg-white rounded-2xl w-full max-w-xl shadow-2xl max-h-[90vh] overflow-y-auto">
        {/* Close Button */}
        <button 
          onClick={onClose}
          className="absolute top-3 right-3 p-1.5 hover:bg-gray-100 rounded-full transition-colors z-10"
          data-testid="lead-modal-close-btn"
        >
          <X className="w-5 h-5 text-gray-500" />
        </button>

        {/* Form */}
        <div className="p-6">
          <h3 className="font-bold text-lg text-gray-900 mb-0.5">Schedule Install</h3>
          <p className="text-xs text-gray-500 mb-3">
            Fill out the form below and our team will contact you shortly.
          </p>

          {selectedProduct && selectedProduct.installed_price > 0 && (
            <div className="bg-emerald-50 border border-emerald-200 rounded-lg p-4 mb-4" data-testid="lead-form-pricing">
              <p className="font-bold text-gray-900 text-lg mb-0.5">{selectedProduct.name}</p>
              <p className="text-emerald-700 text-base mb-1">
                No Money Down, No Payments for 6 Months and No Pre-payment Penalty!
              </p>
              <p className="text-3xl font-bold text-emerald-700">
                {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 }).format(selectedProduct.installed_monthly)} per month
              </p>
              <p className="text-2xl text-gray-800">
                Just <span className="font-bold">{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0 }).format(selectedProduct.installed_price)}</span> Installed
              </p>
            </div>
          )}

          <LeadForm 
            selectedProduct={selectedProduct} 
            onSuccess={onClose}
            compact={true}
          />
        </div>
      </div>
    </div>
  );
};

export default LeadFormModal;
